export { default } from './MultiCard';
